// @ts-nocheck
import React from 'react';
import { Stack as MuiStack } from '@mui/material';

/**
 * SolyticsStack - A wrapper around MUI Stack component
 *
 * Manages layout of immediate children along the vertical or horizontal axis
 * with optional spacing between them. Ideal for 1-dimensional layouts.
 *
 * @component
 * @example
 * // Vertical stack with spacing (default)
 * <SolyticsStack spacing={2}>
 *   <Item>Item 1</Item>
 *   <Item>Item 2</Item>
 *   <Item>Item 3</Item>
 * </SolyticsStack>
 *
 * @example
 * // Horizontal stack with dividers
 * <SolyticsStack
 *   direction="row"
 *   spacing={2}
 *   divider={<SolyticsDivider orientation="vertical" flexItem />}
 * >
 *   <Item>Item 1</Item>
 *   <Item>Item 2</Item>
 * </SolyticsStack>
 *
 * @example
 * // Responsive stack (column on mobile, row on desktop)
 * <SolyticsStack
 *   direction={{ xs: 'column', sm: 'row' }}
 *   spacing={{ xs: 1, sm: 2, md: 4 }}
 * >
 *   <Item>Item 1</Item>
 *   <Item>Item 2</Item>
 * </SolyticsStack>
 *
 * @example
 * // With transitions (ref forwarding)
 * <Fade>
 *   <SolyticsStack spacing={2}>
 *     <p>Animated stack</p>
 *   </SolyticsStack>
 * </Fade>
 */
const SolyticsStack = React.forwardRef((props, ref) => {
  return <MuiStack ref={ref} {...props} />;
});

SolyticsStack.displayName = 'SolyticsStack';

export default SolyticsStack;
